import { ArrowDown, ArrowUp, ChevronSelectorVertical } from "../../icons/v2-stroke";
import { cn } from "../../lib/utils";
export const ALIGN_TEXT_CLASS = {
  left: "text-left",
  right: "text-right",
  center: "text-center"
};
export const ALIGN_JUSTIFY_CLASS = {
  left: "justify-start",
  right: "justify-end",
  center: "justify-center"
};

/** Resolves alignment, sizing and sortability from a column's `meta.type`. */
export function getDataTableColumnPresets(column) {
  var _meta$headerAlign;
  const meta = column.columnDef.meta;
  const align = (meta === null || meta === void 0 ? void 0 : meta.type) === "numeric" ? "right" : (meta === null || meta === void 0 ? void 0 : meta.type) === "row-actions" ? "center" : "left";
  return {
    align,
    headerAlign: (_meta$headerAlign = meta === null || meta === void 0 ? void 0 : meta.headerAlign) !== null && _meta$headerAlign !== void 0 ? _meta$headerAlign : align,
    cellClassName: cn((meta === null || meta === void 0 ? void 0 : meta.type) === "numeric" && "tabular-nums whitespace-nowrap", (meta === null || meta === void 0 ? void 0 : meta.type) === "status" && "whitespace-nowrap", (meta === null || meta === void 0 ? void 0 : meta.type) === "row-actions" && "w-12") || undefined,
    headerClassName: cn((meta === null || meta === void 0 ? void 0 : meta.type) === "numeric" && "tabular-nums", (meta === null || meta === void 0 ? void 0 : meta.type) === "row-actions" && "w-12") || undefined,
    // A column with no header text has nowhere to show a sort control.
    sortable: (meta === null || meta === void 0 ? void 0 : meta.type) !== "row-actions" && column.columnDef.header !== ""
  };
}
export function getSortIcon(sorted) {
  switch (sorted) {
    case "asc":
      return ArrowUp;
    case "desc":
      return ArrowDown;
    default:
      return ChevronSelectorVertical;
  }
}
//# sourceMappingURL=presets.js.map